export const CIQ_SHELL_EVENTS = {
  CLOSE_SHELL: 'ciq:closeShell',
  UPDATE_CONTEXT: 'ciq:updateContext',
  CLEAR_CONTEXT: 'ciq:clearContext',
} as const;
